export default __webpack_public_path__ + "static/screen_1_02-414d17a80942ae3e958ac5308a30bb83.svg";